import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import ApplicationCard from './ApplicationCard';
import { useTranslation } from 'react-i18next';
import { systemModules } from '@hooks/Applications/systemModules';
import { BsGrid3X3, BsList } from 'react-icons/bs';
import ListView from './ListView';
import useLookupModule from '@hooks/Lookups/use-Lookup-Module';
import { ntxAPI } from '@API/axiosNeatex';
import Loading from '@components/Shared/Loader/Loading';
import { type APIResponse } from '@store/Shared/shared';
import ToastSwal from '@components/Shared/Alert/ToastSwal';
import { useAppDispatch } from '@store/hooks';
import { GetModule } from '@store/Lookup/lookupSlice';

const Apps = () => {
  const [isListView, setIsListView] = useState(false);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState<{ [key: string]: boolean }>({}); // Track loading state for each module

  const { Module, loading, error } = useLookupModule();

  // const listApplications = useMemo(
  //   () =>
  //     [
  //       {
  //         id: systemModules.GeneralSystem.id,
  //         name: t('Settings'),
  //         icon: 'icon-park-twotone:setting-one',
  //         color: 'var(--bs-theme)',
  //         Code: 'NTX',
  //         description:
  //           ' The systems control center, where you manage general application settings, user permissions, and all fundamental aspects that ensure smooth and efficient system operation.',
  //         description2:
  //           'مركز التحكم بالنظام، حيث يمكنك إدارة الإعدادات العامة للتطبيق، وصلاحيات المستخدمين، وكل الجوانب الأساسية التي تضمن عمل النظام بسلاسة وفعالية.'
  //       },
  //       {
  //         id: systemModules.HumanResources.id,
  //         name: t('hr'),
  //         icon: 'solar:user-bold-duotone',
  //         color: '#ff5722',
  //         Code: 'HR',

  //         description:
  //           'This module manages everything related to employees, from their personal records and onboarding processes to offboarding and performance management.',
  //         description2:
  //           ' يدير هذا الموديل كل ما يتعلق بالموظفين، من سجلاتهم الشخصية وعمليات التوظيف وحتى إنهاء الخدمة وإدارة الأداء.'
  //       },
  //       {
  //         id: systemModules.PayrollManagement.id,
  //         name: t('payrollManagement'),
  //         icon: 'solar:wallet-bold-duotone',
  //         color: '#4caf50',
  //         Code: 'PAYROLL',

  //         description:
  //           'Comprehensive payroll solutions, encompassing salary calculations, deductions, benefits, and the preparation of accurate financial reports for employees.',
  //         description2:
  //           'حلول متكاملة لإدارة كشوف الرواتب، يشمل حساب الرواتب، الخصومات، المزايا، وإعداد تقارير مالية دقيقة للموظفين.'
  //       },
  //       {
  //         id: systemModules.AttendanceManagement.id,
  //         name: t('attendanceManagement'),
  //         // icon: 'solar:calendar-bold-duotone',
  //         icon: 'mdi:fingerprint',
  //         color: '#2196f3',
  //         Code: 'RAQEEB',

  //         description:
  //           'Track employee attendance accurately and easily. It manages clock-ins/outs, leave requests, and provides detailed attendance reports.',
  //         description2:
  //           ' تتبع حضور الموظفين بدقة وسهولة. يدير عمليات تسجيل الدخول والخروج، طلبات الإجازات، ويقدم تقارير مفصلة عن الحضور والانصراف.'
  //       },
  //       {
  //         id: systemModules.ApprovalsManagement.id,
  //         name: t('approvalsManagement'),
  //         icon: 'grommet-icons:folder-cycle',
  //         color: '#9c27b0',
  //         Code: 'AME',

  //         description:
  //           'Comprehensive automation for approval workflows. It streamlines request routing and status tracking, ensuring quick and organized approval processes across the system.',
  //         description2:
  //           ' أتمتة شاملة لسير عمل الموافقات. يسهل توجيه الطلبات وتتبع حالتها، لضمان عمليات موافقة سريعة ومنظمة عبر النظام.'
  //       },
  //       {
  //         id: systemModules.FinanceManagement.id,
  //         name: t('financeManagement'),
  //         icon: 'mdi:coin',
  //         color: '#e91e63',
  //         Code: 'FIN',

  //         description2:
  //           'إدارة مالية قوية تشمل دفتر الأستاذ العام، الميزانيات، إعداد التقارير المالية، ومراقبة التدفقات النقدية لضمان صحة مالية مستقرة لمؤسستك.',
  //         description:
  //           ' Robust financial management covering the general ledger, budgeting, financial reporting, and cash flow monitoring to ensure stable financial health for your organization.'
  //       },
  //       {
  //         id: systemModules.PayablesManagement.id,
  //         name: t('payablesManagement'),
  //         icon: 'mdi:credit-card-outline',
  //         color: '#009688',
  //         Code: 'AP',

  //         description:
  //           'Full control over managing payments to suppliers. This includes invoice processing, payment scheduling, and effective vendor relationship management.',
  //         description2:
  //           ' تحكم كامل في إدارة المدفوعات للموردين. يشمل معالجة الفواتير، جدولة الدفعات، وإدارة علاقات فعالة مع البائعين.'
  //       },
  //       {
  //         id: systemModules.ReceivablesManagement.id,
  //         name: t('receivablesManagement'),
  //         icon: 'mdi:account-cash',
  //         color: '#3f51b5',
  //         Code: 'AR',

  //         description:
  //           ' Smart management of receivables from customers. It handles invoicing, payment tracking, and ensures efficient revenue collection.',
  //         description2: 'إدارة ذكية للمستحقات من العملاء. يتولى الفوترة، تتبع المدفوعات، وضمان تحصيل الإيرادات بفعالية.'
  //       },
  //       {
  //         id: systemModules.InventoryManagement.id,
  //         name: t('inventoryManagement'),
  //         icon: 'mdi:store-cog',
  //         color: '#00bcd4',
  //         Code: 'INV',

  //         description:
  //           'Precise inventory control. Track stock levels, movement, valuation, and efficiently manage warehouses to ensure product availability at all times.',
  //         description2:
  //           ' مراقبة دقيقة للمخزون. تتبع مستويات البضائع، حركتها، تقييمها، وإدارة المخازن بكفاءة لضمان توفر المنتجات دائمًا.'
  //       },
  //       {
  //         id: systemModules.PurchaseManagement.id,
  //         name: t('purchaseManagement'),
  //         icon: 'tabler:shopping-cart-cog',
  //         color: '#8bc34a',
  //         Code: 'PUR',

  //         description:
  //           ' This module facilitates the entire procurement process, from submitting purchase requisitions to issuing final purchase orders and selecting the best suppliers.',
  //         description2:
  //           'يسهل هذا الموديل عملية الشراء بأكملها، من تقديم طلبات الشراء إلى إصدار أوامر الشراء النهائية واختيار أفضل الموردين.'
  //       },
  //       {
  //         id: systemModules.SalesManagement.id,
  //         name: t('salesManagement'),
  //         icon: 'carbon:sales-ops',
  //         color: '#ff1744',
  //         Code: 'SAL',

  //         description:
  //           ' Drive sales forward. It manages customer relationships, processes orders, assists in sales forecasting, and provides analytical reports on sales performance.',
  //         description2:
  //           ' دفع عجلة المبيعات للأمام. يدير علاقات العملاء، يعالج الطلبات، يساعد في التنبؤ بالمبيعات، ويقدم تقارير تحليلية لأداء المبيعات.'
  //       },
  //       {
  //         id: systemModules.FixedAssetsManagement.id,
  //         name: t('assetsManagement'),
  //         icon: 'solar:box-bold-duotone',
  //         color: '#ff9800',
  //         Code: 'ASSETS',

  //         description:
  //           'Comprehensive management of your organizations fixed assets such as property and equipment, with full tracking of their acquisition, depreciation, and disposal.',
  //         description2:
  //           ' إدارة شاملة لأصول مؤسستك الثابتة مثل العقارات والمعدات، مع تتبع كامل لحيازتها، استهلاكها، وحتى التخلص منها.'
  //       },
  //       {
  //         id: systemModules.PointOfSalesManagement.id,
  //         name: t('posManagement'),
  //         icon: 'ic:twotone-point-of-sale',
  //         color: '#2196f3',
  //         Code: 'POS',

  //         description:
  //           'An ideal solution for retail operations. It handles transactions at the point of sale, manages customer interactions, and ensures smooth payment processing.',
  //         description2:
  //           ': حل مثالي لعمليات البيع بالتجزئة. يتعامل مع المعاملات في نقطة البيع، يدير تفاعلات العملاء، ويضمن معالجة سلسة للمدفوعات.'
  //       },

  //       {
  //         id: systemModules.FleetManagement.id,
  //         name: t('fleetManagement'),
  //         icon: 'mdi:truck',
  //         color: '#ff4081',
  //         Code: 'FLEET',

  //         description:
  //           'Optimize your organizations vehicle fleet management. It includes maintenance, tracking, fuel consumption monitoring, and increasing operational efficiency for vehicles.',
  //         description2:
  //           ': تحسين إدارة أسطول المركبات في مؤسستك. يشمل الصيانة، التتبع، مراقبة استهلاك الوقود، وزيادة الكفاءة التشغيلية للمركبات.'
  //       },
  //       {
  //         id: systemModules.SupportingUnits.id,
  //         name: t('supportingUnits'),
  //         icon: 'solar:home-bold-duotone',
  //         color: '#3f51b5',
  //         Code: 'SU',

  //         description:
  //           ' This module gathers essential functions that support the organizations daily operations, ensuring efficient provision of shared and administrative services.',
  //         description2:
  //           ' يجمع هذا الموديل الوظائف الأساسية التي تدعم العمليات اليومية للمؤسسة، ويضمن توفير الخدمات المشتركة والإدارية بفعالية.'
  //       },
  //       {
  //         id: systemModules.ReportsManagement.id,
  //         name: t('reportsManagement'),
  //         icon: 'mdi:file-document-outline',
  //         color: '#673ab7',
  //         Code: 'REPORT',

  //         description:
  //           'Your gateway to smart insights. It provides powerful tools to generate detailed reports across all modules, empowering you to make informed, data-driven decisions.',
  //         description2:
  //           'بوابتك للرؤى الذكية. يوفر أدوات قوية لإنشاء تقارير مفصلة عبر كل الموديلات، مما يمكنك من اتخاذ قرارات مستنيرة بناءً على البيانات.'
  //       },
  //       {
  //         id: systemModules.NotificationsSystem.id,
  //         name: t('notificationsSystem'),
  //         icon: 'solar:bell-bold-duotone',
  //         color: '#3f51b5',
  //         Code: 'NOTIFICATION',

  //         description: ` The smart notification system. It keeps you constantly updated with all important events and required actions within the system so you don't miss anything new.`,
  //         description2:
  //           'نظام الإشعارات الذكي. يبقيك على اطلاع دائم بجميع الأحداث الهامة والإجراءات المطلوبة داخل النظام لعدم تفويت أي جديد.'
  //       },
  //       {
  //         id: systemModules.IntegrationManagement.id,
  //         name: t('integrationManagement'),
  //         icon: 'ph:link-duotone',
  //         color: '#4caf50',
  //         Code: 'INT',

  //         description:
  //           'Seamless integration between your systems. It ensures efficient data exchange between internal and external systems, maximizing harmony and effective operation.',
  //         description2:
  //           ' الربط السلس بين أنظمتك. يضمن تبادل البيانات بفعالية بين الأنظمة الداخلية والخارجية، لتحقيق أقصى قدر من التناغم والتشغيل الفعال.'
  //       }
  //     ].map(app => ({
  //       ...app,
  //       active: Module?.find((f: any) => f.id === app.id)?.isActive
  //     })),
  //   [Module, t]
  // );

  const [listApplications, setListApplications] = useState<any[]>([]);

  useEffect(() => {
    if (!systemModules || !Module) return;

    const apps = [
      {
        id: systemModules.GeneralSystem.id,
        name: t('Settings'),
        icon: 'icon-park-twotone:setting-one',
        color: 'var(--bs-theme)',
        Code: 'NTX',
        description:
          ' The systems control center, where you manage general application settings, user permissions, and all fundamental aspects that ensure smooth and efficient system operation.',
        description2:
          'مركز التحكم بالنظام، حيث يمكنك إدارة الإعدادات العامة للتطبيق، وصلاحيات المستخدمين، وكل الجوانب الأساسية التي تضمن عمل النظام بسلاسة وفعالية.'
      },
      {
        id: systemModules.HumanResources.id,
        name: t('hr'),
        icon: 'solar:user-bold-duotone',
        color: '#ff5722',
        Code: 'HR',

        description:
          'This module manages everything related to employees, from their personal records and onboarding processes to offboarding and performance management.',
        description2:
          ' يدير هذا الموديل كل ما يتعلق بالموظفين، من سجلاتهم الشخصية وعمليات التوظيف وحتى إنهاء الخدمة وإدارة الأداء.'
      },
      {
        id: systemModules.PayrollManagement.id,
        name: t('payrollManagement'),
        icon: 'solar:wallet-bold-duotone',
        color: '#4caf50',
        Code: 'PAYROLL',

        description:
          'Comprehensive payroll solutions, encompassing salary calculations, deductions, benefits, and the preparation of accurate financial reports for employees.',
        description2:
          'حلول متكاملة لإدارة كشوف الرواتب، يشمل حساب الرواتب، الخصومات، المزايا، وإعداد تقارير مالية دقيقة للموظفين.'
      },
      {
        id: systemModules.AttendanceManagement.id,
        name: t('attendanceManagement'),
        // icon: 'solar:calendar-bold-duotone',
        icon: 'mdi:fingerprint',
        color: '#2196f3',
        Code: 'RAQEEB',

        description:
          'Track employee attendance accurately and easily. It manages clock-ins/outs, leave requests, and provides detailed attendance reports.',
        description2:
          ' تتبع حضور الموظفين بدقة وسهولة. يدير عمليات تسجيل الدخول والخروج، طلبات الإجازات، ويقدم تقارير مفصلة عن الحضور والانصراف.'
      },
      {
        id: systemModules.ApprovalsManagement.id,
        name: t('approvalsManagement'),
        icon: 'grommet-icons:folder-cycle',
        color: '#9c27b0',
        Code: 'AME',

        description:
          'Comprehensive automation for approval workflows. It streamlines request routing and status tracking, ensuring quick and organized approval processes across the system.',
        description2:
          ' أتمتة شاملة لسير عمل الموافقات. يسهل توجيه الطلبات وتتبع حالتها، لضمان عمليات موافقة سريعة ومنظمة عبر النظام.'
      },
      {
        id: systemModules.FinanceManagement.id,
        name: t('financeManagement'),
        icon: 'mdi:coin',
        color: '#e91e63',
        Code: 'FIN',

        description2:
          'إدارة مالية قوية تشمل دفتر الأستاذ العام، الميزانيات، إعداد التقارير المالية، ومراقبة التدفقات النقدية لضمان صحة مالية مستقرة لمؤسستك.',
        description:
          ' Robust financial management covering the general ledger, budgeting, financial reporting, and cash flow monitoring to ensure stable financial health for your organization.'
      },
      {
        id: systemModules.PayablesManagement.id,
        name: t('payablesManagement'),
        icon: 'mdi:credit-card-outline',
        color: '#009688',
        Code: 'AP',

        description:
          'Full control over managing payments to suppliers. This includes invoice processing, payment scheduling, and effective vendor relationship management.',
        description2:
          ' تحكم كامل في إدارة المدفوعات للموردين. يشمل معالجة الفواتير، جدولة الدفعات، وإدارة علاقات فعالة مع البائعين.'
      },
      {
        id: systemModules.ReceivablesManagement.id,
        name: t('receivablesManagement'),
        icon: 'mdi:account-cash',
        color: '#3f51b5',
        Code: 'AR',

        description:
          ' Smart management of receivables from customers. It handles invoicing, payment tracking, and ensures efficient revenue collection.',
        description2: 'إدارة ذكية للمستحقات من العملاء. يتولى الفوترة، تتبع المدفوعات، وضمان تحصيل الإيرادات بفعالية.'
      },
      {
        id: systemModules.InventoryManagement.id,
        name: t('inventoryManagement'),
        icon: 'mdi:store-cog',
        color: '#00bcd4',
        Code: 'INV',

        description:
          'Precise inventory control. Track stock levels, movement, valuation, and efficiently manage warehouses to ensure product availability at all times.',
        description2:
          ' مراقبة دقيقة للمخزون. تتبع مستويات البضائع، حركتها، تقييمها، وإدارة المخازن بكفاءة لضمان توفر المنتجات دائمًا.'
      },
      {
        id: systemModules.PurchaseManagement.id,
        name: t('purchaseManagement'),
        icon: 'tabler:shopping-cart-cog',
        color: '#8bc34a',
        Code: 'PUR',

        description:
          ' This module facilitates the entire procurement process, from submitting purchase requisitions to issuing final purchase orders and selecting the best suppliers.',
        description2:
          'يسهل هذا الموديل عملية الشراء بأكملها، من تقديم طلبات الشراء إلى إصدار أوامر الشراء النهائية واختيار أفضل الموردين.'
      },
      {
        id: systemModules.SalesManagement.id,
        name: t('salesManagement'),
        icon: 'carbon:sales-ops',
        color: '#ff1744',
        Code: 'SAL',

        description:
          ' Drive sales forward. It manages customer relationships, processes orders, assists in sales forecasting, and provides analytical reports on sales performance.',
        description2:
          ' دفع عجلة المبيعات للأمام. يدير علاقات العملاء، يعالج الطلبات، يساعد في التنبؤ بالمبيعات، ويقدم تقارير تحليلية لأداء المبيعات.'
      },
      {
        id: systemModules.FixedAssetsManagement.id,
        name: t('assetsManagement'),
        icon: 'solar:box-bold-duotone',
        color: '#ff9800',
        Code: 'ASSETS',

        description:
          'Comprehensive management of your organizations fixed assets such as property and equipment, with full tracking of their acquisition, depreciation, and disposal.',
        description2:
          ' إدارة شاملة لأصول مؤسستك الثابتة مثل العقارات والمعدات، مع تتبع كامل لحيازتها، استهلاكها، وحتى التخلص منها.'
      },
      {
        id: systemModules.PointOfSalesManagement.id,
        name: t('posManagement'),
        icon: 'ic:twotone-point-of-sale',
        color: '#2196f3',
        Code: 'POS',

        description:
          'An ideal solution for retail operations. It handles transactions at the point of sale, manages customer interactions, and ensures smooth payment processing.',
        description2:
          ': حل مثالي لعمليات البيع بالتجزئة. يتعامل مع المعاملات في نقطة البيع، يدير تفاعلات العملاء، ويضمن معالجة سلسة للمدفوعات.'
      },

      {
        id: systemModules.FleetManagement.id,
        name: t('fleetManagement'),
        icon: 'mdi:truck',
        color: '#ff4081',
        Code: 'FLEET',

        description:
          'Optimize your organizations vehicle fleet management. It includes maintenance, tracking, fuel consumption monitoring, and increasing operational efficiency for vehicles.',
        description2:
          ': تحسين إدارة أسطول المركبات في مؤسستك. يشمل الصيانة، التتبع، مراقبة استهلاك الوقود، وزيادة الكفاءة التشغيلية للمركبات.'
      },
      {
        id: systemModules.SupportingUnits.id,
        name: t('supportingUnits'),
        icon: 'solar:home-bold-duotone',
        color: '#3f51b5',
        Code: 'SU',

        description:
          ' This module gathers essential functions that support the organizations daily operations, ensuring efficient provision of shared and administrative services.',
        description2:
          ' يجمع هذا الموديل الوظائف الأساسية التي تدعم العمليات اليومية للمؤسسة، ويضمن توفير الخدمات المشتركة والإدارية بفعالية.'
      },
      {
        id: systemModules.ReportsManagement.id,
        name: t('reportsManagement'),
        icon: 'mdi:file-document-outline',
        color: '#673ab7',
        Code: 'REPORT',

        description:
          'Your gateway to smart insights. It provides powerful tools to generate detailed reports across all modules, empowering you to make informed, data-driven decisions.',
        description2:
          'بوابتك للرؤى الذكية. يوفر أدوات قوية لإنشاء تقارير مفصلة عبر كل الموديلات، مما يمكنك من اتخاذ قرارات مستنيرة بناءً على البيانات.'
      },
      {
        id: systemModules.NotificationsSystem.id,
        name: t('notificationsSystem'),
        icon: 'solar:bell-bold-duotone',
        color: '#3f51b5',
        Code: 'NOTIFICATION',

        description: ` The smart notification system. It keeps you constantly updated with all important events and required actions within the system so you don't miss anything new.`,
        description2:
          'نظام الإشعارات الذكي. يبقيك على اطلاع دائم بجميع الأحداث الهامة والإجراءات المطلوبة داخل النظام لعدم تفويت أي جديد.'
      },
      {
        id: systemModules.IntegrationManagement.id,
        name: t('integrationManagement'),
        icon: 'ph:link-duotone',
        color: '#4caf50',
        Code: 'INT',

        description:
          'Seamless integration between your systems. It ensures efficient data exchange between internal and external systems, maximizing harmony and effective operation.',
        description2:
          ' الربط السلس بين أنظمتك. يضمن تبادل البيانات بفعالية بين الأنظمة الداخلية والخارجية، لتحقيق أقصى قدر من التناغم والتشغيل الفعال.'
      }
    ];

    const enrichedApps = apps.map(app => ({
      ...app,
      // status: Module?.find((f: any) => f.id === app.id)?.isActive ? 'Active' : 'Inactive'
      isActive: Module?.find((f: any) => f.id === app.id)?.isActive
    }));

    setListApplications(enrichedApps);
  }, [t, systemModules, Module]);

  const toggleView = () => {
    setIsListView(!isListView);
  };

  // const handleStatusChange = (id: any, newStatus: any) => {
  //   setListApplications(prev => prev.map(app => (app.id === id ? { ...app, isActive: newStatus } : app)));
  // };

  const changeModuleStatus = async (moduleId: string, status: boolean) => {
    try {
      setIsSubmitting(prev => ({ ...prev, [moduleId]: true })); // Set loading state for specific module
      const { data } = await ntxAPI.post<APIResponse<boolean>>('NtxSetting/ChangeModuleStatus', {
        moduleId: moduleId,
        isActive: status
      });
      if (data.data === true && data.succeeded === true) {
        ToastSwal({
          icon: 'success',
          position: 'center',
          timer:1000,
          text: status
            ? i18n.language === 'ar'
              ? 'تم تفعيل الموديل بنجاح'
              : 'Module activated successfully'
            : i18n.language === 'ar'
            ? 'تم إلغاء تفعيل الموديل'
            : 'Module deactivated successfully'
        });
        await dispatch(GetModule());
        // handleStatusChange(moduleId, status);
        return data;
      } else {
        ToastSwal({
          icon: 'warning',
          position: 'center',
          text:
            i18n.language === 'ar'
              ? 'حدث خطأ أثناء تغيير حالة الموديل'
              : 'Something went wrong while changing the module status'
        });
      }
    } catch (error) {
      console.error('Error changing module status:', error);
      throw error;
    } finally {
      setIsSubmitting(prev => ({ ...prev, [moduleId]: false })); // Clear loading state for specific module
    }
  };

  const CountActive = listApplications.filter(f => f.isActive)?.length;

  return (
    <>
      <div
        className='border border-1 border-theme'
        style={{
          position: 'sticky',
          top: 55, // يلتصق بالجزء العلوي من منطقة العرض
          zIndex: 1000, // يضمن بقاءه فوق المحتوى الآخر
          backgroundColor: 'var(--bs-body-bg)', // خلفية لتجنب شفافية المحتوى تحته
          // paddingBottom: '1rem', // إضافة بعض المسافة أسفله
          padding: '8px ',
          // marginBottom: '1rem', // مسافة بين الشريط الثابت والمحتوى التالي
          boxShadow: '0 2px 4px rgba(0,0,0,.1)' // لإضافة ظل خفيف (اختياري)
        }}
      >
        <div className='row  align-items-center'>
          <div className='col-lg-9'>
            <div className='input-group flex-nowrap'>
              <span className='input-group-text fw-bold'>
                <i className='fa fa-search text-theme me-2'></i>
                {t('Search')}
              </span>
              <input
                type='search'
                autoComplete='off'
                className='form-control'
                placeholder='Search applications...'
                style={{ paddingLeft: '2rem' }}
              />
            </div>
          </div>

          <div className='col-lg-3 text-end '>
            <div className='d-flex justify-content-end align-items-center'></div>
            <button
              type='button'
              className={`btn   me-2 ${!isListView ? ' btn-theme' : ' btn-outline-theme'}`}
              onClick={() => isListView && toggleView()}
            >
              <BsGrid3X3 size={20} />
            </button>
            <button
              type='button'
              className={`btn  me-2 ${isListView ? ' btn-theme' : ' btn-outline-theme'}`}
              onClick={() => !isListView && toggleView()}
            >
              <BsList size={20} />
            </button>

            <span className='badge bg-theme fs-6 py-2 px-3'>
              {t('IsActive')} {CountActive}
            </span>
          </div>
        </div>
      </div>

      <Loading loading={loading} error={error}>
        <div className='p-3'>
          {!isListView && (
            <Row xs={1} sm={2} md={3} lg={4} className='g-4'>
              {listApplications
                .filter(f => f.Code !== 'USER')
                .map(app => (
                  <Col key={app.id}>
                    <ApplicationCard
                      app={app}
                      onStatusChange={changeModuleStatus}
                      isSubmitting={isSubmitting[app.id] || false}
                    />
                  </Col>
                ))}
            </Row>
          )}
          {isListView && (
            <>
              {listApplications
                .filter(f => f.Code !== 'USER')
                .map(app => (
                  <div key={app.id}>
                    <ListView
                      app={app}
                      onStatusChange={changeModuleStatus}
                      isSubmitting={isSubmitting[app.id] || false}
                    />
                  </div>
                ))}
            </>
          )}

          {/* {isListView && <ListView app={listApplications.filter(f => f.Code !== 'USER')}  />} */}
        </div>
      </Loading>
    </>
  );
};

export default Apps;

//   const context = useContext(AppSettings);

//   useEffect(() => {
//     context.setAppFooter(true);

//     return function cleanUp() {
//       context.setAppFooter(false);
//     };

//     // eslint-disable-next-line
//   }, []);
